import { VEHICLE_TYPE } from '@/utils/constants'
import { handleLocation } from '@/utils/searchData'
import { createUrlAd, createUrlIdc, createUrlPhotoAd } from '@/utils/utils'
import { config } from 'config/config'

export const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  initialSlide: 0,
  draggable: false,
  swipe: false,
  touchMove: false,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 5, 
      },
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 4, 
      },
    },
    {
      breakpoint: 1024, 
      settings: {
        slidesToShow: 3, 
      },
    },
    {
      breakpoint: 765, 
      settings: {
        slidesToShow: 2, 
      },
    },
    {
      breakpoint: 500, 
      settings: {
        slidesToShow: 1, 
      },
    },
  ],
};


export function replaceBackslashes(str) {
  return str.replace(/\\/g, '/')
}

export function formatPrice(price) {
  try {
    const priceNumber = parseFloat(price)
    const formattedPrice = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(priceNumber)

    return formattedPrice
  } catch (error) {
    return '-'
  }
}

export function formatKilometers(kilometers) {
  return `${kilometers.toLocaleString('pt-BR')} Km`
}

export const transformVehicleData = (vehicle, vehicleType) => {
  const { UniqueId, PhotoPath, Specification, Seller, Price } = vehicle
  const {
    Make,
    Model,
    Version,
    YearFabrication,
    YearModel,
    Odometer,
    ListingType,
  } = Specification

  const { noPhoto: NO_PHOTO, photoSearchResultBig } = config

  const linkCard = createUrlIdc(
    createUrlAd(vehicle, vehicleType, ''),
    'webmotors',
    'recomendacao',
    'recomendacoes:comprar'
  )

  const linkThumb = PhotoPath
    ? createUrlPhotoAd(
        replaceBackslashes(PhotoPath),
        vehicleType,
        ListingType,
        photoSearchResultBig
      )
    : NO_PHOTO

  const make = Make.Value
  const model = Model.Value
  let description = ''

  if (vehicleType === VEHICLE_TYPE.car) {
    description = Version.Value
  }

  return {
    uniqueId: UniqueId,
    linkCard,
    linkThumb,
    make,
    model,
    description,
    price: formatPrice(Price),
    year: `${YearFabrication}/${YearModel}`,
    km: formatKilometers(Odometer),
    city: handleLocation({ city: Seller.City, state: Seller.State }),
    tag: {
      alt: `${make}-${model}-${YearFabrication}`,
      title: `${make}-${model}${description}`,
    },
  }
}
